import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { ReactLayout } from "./ReactLayout";

/**
 * При помощи порталов добавляет к гео-объекту children-prop.
 *
 * В будущем может добавиться optionsAdapter, который будет передавать radius & geometry в CustomLayout
 */
export var withReactLayout = function withReactLayout(WrappedGeoObject) {
  var WithReactLayout = function WithReactLayout(_ref) {
    var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WrappedGeoObject, _extends({}, props, {
      "data-t-id": "maps-kit-enhancers"
    })), children && /*#__PURE__*/React.createElement(ReactLayout, {
      geometry: props.geometry,
      radius: props.radius
    }, children));
  };
  WithReactLayout.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, WrappedGeoObject.propTypes), {}, {
    children: PropTypes.node,
    className: PropTypes.string,
    geometry: PropTypes.arrayOf(PropTypes.number),
    radius: PropTypes.number
  }) : {};
  return WithReactLayout;
};